import React from "react";
import { useNavigate } from "react-router-dom";
import { createAdmin } from "src/actions/watcher/adminsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewError, setNewParams, AdminRecordInterface } from "src/store/watcher/adminsSlice";

import Form from './_partials/_Form';
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch  = useAppDispatch();
  const params = useAppSelector(state => state.watcher.admins.newParams);
  const error = useAppSelector(state => state.watcher.admins.newError);

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: AdminRecordInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createAdmin(data));

    if (createAdmin.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-admin'>
        <h6 className="v-content-label">Create Admin</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
